import React from "react";
import { Link } from "react-router-dom";
import { PublicPage, PageIntro, GREEN, GOLD, INK } from "../../components/public/PublicChrome";
import { legal, site, fillTokens } from "../../content/siteData";

const OTHER_DOCS = [
  { key: "terminos", label: "Términos y condiciones" },
  { key: "privacidad", label: "Política de privacidad" },
  { key: "reembolsos", label: "Reembolsos y cancelación" },
];

export default function LegalPage({ doc }) {
  const d = legal[doc];
  return (
    <PublicPage title={d.titulo} description={d.descripcion}>
      <PageIntro eyebrow="Legal" title={d.titulo}>
        <p>Última actualización: {site.legal.actualizado}</p>
      </PageIntro>

      <article className="max-w-3xl mx-auto px-6 sm:px-8 py-14 md:py-16" data-testid={`legal-${doc}`}>
        <p className="text-[16px] leading-relaxed mb-10" style={{ color: `${INK}cc` }}>
          {fillTokens(d.intro)}
        </p>

        {d.secciones.map((s) => (
          <section key={s.titulo} className="mb-9">
            <h2 className="font-display text-2xl md:text-[28px] mb-3" style={{ color: GREEN }}>
              {s.titulo}
            </h2>
            {(s.parrafos || []).map((p, i) => (
              <p key={i} className="text-[15px] leading-relaxed mb-3" style={{ color: `${INK}bb` }}>
                {fillTokens(p)}
              </p>
            ))}
            {s.lista && (
              <ul className="list-disc pl-5 space-y-2 text-[15px] leading-relaxed" style={{ color: `${INK}bb` }}>
                {s.lista.map((li, i) => (
                  <li key={i}>{fillTokens(li)}</li>
                ))}
              </ul>
            )}
          </section>
        ))}

        <nav className="border-t pt-8 mt-12 flex flex-wrap gap-x-6 gap-y-2 text-[14px]" style={{ borderColor: `${GREEN}1a` }}>
          {OTHER_DOCS.filter((o) => o.key !== doc).map((o) => (
            <Link key={o.key} to={legal[o.key].ruta} className="font-medium hover:underline" style={{ color: GOLD }}>
              {o.label}
            </Link>
          ))}
        </nav>
      </article>
    </PublicPage>
  );
}
